import { Sentry, sentryEnabled } from '@/lib/sentry';

type Ctx = Record<string, unknown>;

export const logger = {
  debug(msg: string, ctx?: Ctx) {
    console.debug(msg, ctx);
    if (sentryEnabled) {
      Sentry.addBreadcrumb({ level: 'debug', message: msg, data: ctx });
    }
  },
  info(msg: string, ctx?: Ctx) {
    console.info(msg, ctx);
    if (sentryEnabled) {
      Sentry.addBreadcrumb({ level: 'info', message: msg, data: ctx });
    }
  },
  warn(msg: string, ctx?: Ctx) {
    console.warn(msg, ctx);
    if (sentryEnabled) {
      Sentry.addBreadcrumb({ level: 'warning', message: msg, data: ctx });
    }
  },
  error(msg: string, err?: unknown, ctx?: Ctx) {
    console.error(msg, err, ctx);
    if (!sentryEnabled) return;
    Sentry.withScope((scope) => {
      if (ctx) scope.setContext('log_context', ctx);
      scope.setTag('logger.message', msg);
      Sentry.captureException(err ?? new Error(msg));
    });
  },
};
